// extracted by mini-css-extract-plugin
module.exports = {"space":"Template_space__1yb-E","backGround":"Template_backGround__1QfSy","backGroundGray":"Template_backGroundGray__YokML"};